import moment from "moment-jalaali";
class DateTime {
  Now = () => {
    return Date.now();
  };
  Parse = (timeStr) => {
    return Date.parse(timeStr);
  };
  newDate = (timeStr) => {
    return new Date(this.Parse(timeStr));
  };
  getDiff = (from) => {
    return moment.duration(moment(from).diff(moment(new Date()))).asMinutes();
  };
  getFullYear = (timeStr) => {
    return this.newDate(timeStr).getUTCFullYear();
  };
  getUTCDate = (timeStr) => {
    return this.newDate(timeStr).getUTCDate();
  };
  getDate = (timeStr) => {
    return this.newDate(timeStr).getDate();
  };
  getUTCMonth = (timeStr) => {
    return this.newDate(timeStr).getUTCMonth();
  };
  getMonth = (timeStr) => {
    return this.newDate(timeStr).getMonth();
  };
  getDayShortStr = (str) => {
    switch (str) {
      case "Sat":
        return {
          fa: "ش",
          en: "Sat",
        };
      case "Sun":
        return {
          fa: "ی",
          en: "Sun",
        };
      case "Mon":
        return {
          fa: "د",
          en: "Mon",
        };
      case "Tue":
        return {
          fa: "س",
          en: "Tue",
        };
      case "Wed":
        return {
          fa: "چ",
          en: "Wed",
        };
      case "Thu":
        return {
          fa: "پ",
          en: "Thu",
        };
      case "Fri":
        return {
          fa: "ج",
          en: "fri",
        };
      default:
        break;
    }
  };
  getDayFullStr = (str) => {
    switch (str) {
      case "Sat":
        return {
          fa: "شنبه",
          en: "Saturday",
        };
      case "Sun":
        return {
          fa: "یکشنبه",
          en: "Sunday",
        };
      case "Mon":
        return {
          fa: "دوشنبه",
          en: "Monday",
        };
      case "Tue":
        return {
          fa: "سه شنبه",
          en: "Tuesday",
        };
      case "Wed":
        return {
          fa: "چهارشنبه",
          en: "Wednesday",
        };
      case "Thu":
        return {
          fa: "پنج شنبه",
          en: "Thursday",
        };
      case "Fri":
        return {
          fa: "جمعه",
          en: "Friday",
        };
      default:
        break;
    }
  };
  timeZone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };
}
export default new DateTime();
